import { useQuery } from "@tanstack/react-query";
import { useEffect, useState } from "react";
import { api } from "shared/api";
import { OptionTemplate } from "shared/api/middleware-api-client";
import {
  STATIC_REFERENCE_DATA_CACHE_TIME,
  STATIC_REFERENCE_DATA_STALE_TIME,
} from "shared/config/queryConstants";

export const useExtraData = (
  door: string | undefined,
  color: OptionTemplate | null,
  glass: OptionTemplate | null,
) => {
  const [includedExtraOptions, setIncludedOptions] = useState<
    OptionTemplate[] | undefined
  >(undefined);
  const [allExtraOptions, setAllOptions] = useState<
    OptionTemplate[] | undefined
  >(undefined);

  const excludeOptions = (options: OptionTemplate[] | undefined) => {
    if (options && door && color && glass) {
      return options.filter((option) => {
        if (option.type !== "extra") return false;
        if (!option.typeRestriction.includes(door)) return false;
        if (option.exclude && option.exclude.includes(color.code)) return false;
        if (option.exclude && option.exclude.includes(glass.code)) return false;
        option.amount = 1;
        return true;
      });
    } else if (door) {
      return options;
    } else {
      return [];
    }
  };

  const {
    isLoading: isExtraDataLoading,
    error: isExtraError,
    data: extraData,
  } = useQuery({
    queryKey: ["extraData"],
    queryFn: async () => {
      const res = await api().gersOptionTemplates({
        filter: {
          where: {
            type: "extra",
            disabled: false,
          },
          fields: [
            "id",
            "type",
            "typeRestriction",
            "name",
            "code",
            "material",
            "description",
            "price",
            "default",
            "exclude",
            "imageId",
            "carrouselImageIds",
            "crossSoldOptions",
            "groupLabel",
            "minBeamCount",
          ],
        },
      });
      return res.data;
    },
    refetchOnWindowFocus: false,
    staleTime: STATIC_REFERENCE_DATA_STALE_TIME,
    cacheTime: STATIC_REFERENCE_DATA_CACHE_TIME,
    // enabled: !!door
  });

  useEffect(() => {
    const newOptions = excludeOptions(extraData);

    setIncludedOptions(newOptions);
    setAllOptions(extraData);
  }, [extraData, door, color, glass]);

  return {
    includedExtraOptions,
    allExtraOptions,
    isExtraError,
    isExtraDataLoading,
  };
};
